"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
function ProductsGridConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div data-section-id="183390" className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="h-[400px] animate-pulse rounded-lg bg-muted" />)}
      </div>;
  }
  if (error || products.length === 0) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>Kunde inte ladda våra guider för tillfället. Försök igen senare.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
      {products.map((product, i) => {
      const difficultyTag = product.tags?.find(t => t.name.toLowerCase().includes("lätt") || t.name.toLowerCase().includes("medel") || t.name.toLowerCase().includes("svår"));
      const difficulty = difficultyTag ? difficultyTag.name.replace(/ trail/i, "") : "Medel";
      let badgeVariant: "default" | "secondary" | "destructive" = "secondary";
      if (difficulty.toLowerCase().includes("lätt")) {
        badgeVariant = "default";
      } else if (difficulty.toLowerCase().includes("svår")) {
        badgeVariant = "destructive";
      }
      const destination = product.categories && product.categories.length > 0 ? product.categories[0].name : "Europa";
      return <Card key={product.id} data-index={i} className="group relative flex h-full flex-col overflow-hidden rounded-lg border border-border/60 bg-card transition-all duration-300 hover:border-primary/40 hover:shadow-md">
            {}
            <div className="relative aspect-[4/3] overflow-hidden bg-muted">
              {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center text-sm text-muted-foreground">
                  Bild saknas
                </div>}
              {}
              <div className="absolute right-3 top-3 z-10">
                <Badge variant={badgeVariant} className="font-mono text-[10px] uppercase tracking-wider shadow-sm">
                  {difficulty}
                </Badge>
              </div>
            </div>

            {}
            <CardContent className="relative flex flex-grow flex-col overflow-hidden p-5">
              <div className="mb-2 text-[10px] font-bold uppercase tracking-widest text-muted-foreground">
                {destination}
              </div>
              <h3 className="mb-4 line-clamp-2 text-lg font-semibold tracking-tight text-foreground">
                <Link to={product.link} className="transition-colors hover:text-primary before:absolute before:inset-0 before:z-0">
                  {product.title}
                </Link>
              </h3>

              {}
              <div className="mt-auto pt-2">
                <div className="flex items-center justify-between transition-opacity duration-300 group-hover:opacity-0">
                  <span className="text-lg font-bold text-primary">
                    {product.price !== undefined ? `${product.price} kr` : "Pris på förfrågan"}
                  </span>
                </div>
              </div>

              {}
              <div className="absolute bottom-0 left-0 right-0 z-20 translate-y-full bg-card p-5 transition-transform duration-300 ease-in-out group-hover:translate-y-0">
                <AddToCartButton productId={product.id} className="w-full" buttonClassName="bg-accent text-accent-foreground w-full font-semibold shadow-sm hover:bg-accent/90 transition-colors" text="Välj guide" showQuantity={false} />
              </div>
            </CardContent>
          </Card>;
    })}
    </div>;
}
export default function PopularAdventures() {
  const wp_query_params = {
    per_page: 4,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="populära-resmål" className="bg-background text-foreground px-4 py-24 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <h2 className="mb-4 text-3xl font-bold tracking-tight text-primary md:text-4xl">
            Populära Resmål
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground">
            Utforska våra mest eftertraktade digitala guider för självguidade vandrings- och cykelresor genom Europas vackraste landskap.
          </p>
        </div>

        <EcommerceProductsProvider wp_query={{
        per_page: 4,
        order: "desc",
        orderby: "date"
      }}>
          <ProductsGridConsumer />
        </EcommerceProductsProvider>

        <div className="mt-16 text-center">
          <Link to="/ShopPage">
            <Button variant="outline" size="lg" className="border-accent text-accent hover:bg-accent hover:text-accent-foreground transition-all duration-300 font-semibold">
              Utforska alla resmål
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}